import config from '../../../config/app';
import Form from '../../../components/v2/Form/Form';
import { FieldType } from '../../../components/v2/Form/types';
import React from 'react';
import { useTranslation } from 'utils/translation';
import { applyFilters } from '../../../core';
import dirsConfig from '../../../config/dirs';
import { useAppFeatures } from '../../ui/selectors/app';

export default function DirectoryTypeField() {
  const { t } = useTranslation();
  const features = useAppFeatures();

  const availableTypes = applyFilters(
    'available_directory_types',
    dirsConfig.types,
  );

  const types = Object.keys(availableTypes).map((type) => ({
    value: type,
    label: t(availableTypes[type]),
  }));

  if (!features.devices) {
    return null;
  }

  return (
    <Form.Field
      name="directoryType"
      type={FieldType.Select}
      label={t('Directory Type')}
      rules={{ required: true }}
      options={types}
    />
  );
}
